import React from "react";
import "./Gallery2.css";
import { Swiper, SwiperSlide } from "swiper/react";
import { Autoplay } from "swiper/modules";
import "swiper/css";

const Gallerysec2 = () => {
  return (
    <>
      <div className="container stay-main">
        <h2 className="hdng2">OUR GALLERY</h2>
        <div className="d-flex justify-content-center align-items-center">
          <img className="under" src="./image 506.png" alt="error" />
        </div>
        <div className="mt-4">
          <a className="hdng4" href="/Stay_Gallery">
            <h2 className="text-center hdng4 ">STAY</h2>
          </a>
          <div className="row ">
            <Swiper
              breakpoints={{
                120: {
                  slidesPerView: 1,
                },
                481: {
                  slidesPerView: 2,
                },
                1024: {
                  slidesPerView: 2,
                },
              }}
              modules={[Autoplay]}
              spaceBetween={20}
              slidesPerView={2}
              autoplay
            >
              <div className="col-6 ">
                <SwiperSlide>
                  <img src="./image 162.png" alt="error" className="imgw" />
                </SwiperSlide>
              </div>

              <div className="col-6">
                <SwiperSlide>
                  <img src="./image 163.png" alt="error" className="imgw2" />
                </SwiperSlide>
              </div>

              <div className="col-6">
                <SwiperSlide>
                  <img src="./image 156.png" alt="error" className="imgw3" />
                </SwiperSlide>
              </div>
              <div className="col-6 ">
                <SwiperSlide>
                  <img src="./image 162.png" alt="error" className="imgw" />
                </SwiperSlide>
              </div>
            </Swiper>
          </div>
          <div className="mt-4">
            <h2 className="text-center hdng4">SPACES</h2>
            <div className="row">
              <Swiper
                breakpoints={{
                  120: {
                    slidesPerView: 1,
                  },
                  481: {
                    slidesPerView: 2,
                  },
                  1024: {
                    slidesPerView: 2,
                  },
                }}
                modules={[Autoplay]}
                spaceBetween={20}
                slidesPerView={2}
                autoplay
              >
                {" "}
                <div className="col-6 ">
                  <SwiperSlide>
                    <img
                      src="./IMG-20240625-WA0042 1.png"
                      alt="error"
                      className="imgw"
                    />
                  </SwiperSlide>
                </div>
                <div className="col-6">
                  <SwiperSlide>
                    <img src="./image 157.png" alt="error" className="imgw2" />
                  </SwiperSlide>
                </div>
                <div className="col-6">
                  <SwiperSlide>
                    <img
                      src="./IMG-20240625-WA0060 1.png"
                      alt="error"
                      className="imgw3"
                    />
                  </SwiperSlide>
                </div>
                <div className="col-6 ">
                  <SwiperSlide>
                    <img
                      src="./IMG-20240625-WA0042 1.png"
                      alt="error"
                      className="imgw"
                    />
                  </SwiperSlide>
                </div>
              </Swiper>
            </div>
          </div>
          <div className="mt-4">
            <h2 className="text-center hdng4">CELEBRATIONS</h2>
            <div className="row">
              <Swiper
                breakpoints={{
                  120: {
                    slidesPerView: 1,
                  },
                  481: {
                    slidesPerView: 2,
                  },
                  1024: {
                    slidesPerView: 2,
                  },
                }}
                modules={[Autoplay]}
                spaceBetween={20}
                slidesPerView={2}
                autoplay
              >
                {" "}
                <div className="col-6 ">
                  <SwiperSlide>
                    <img src="./image 160.png" alt="error" className="imgw" />
                  </SwiperSlide>
                </div>
                <div className="col-6">
                  <SwiperSlide>
                    <img
                      src="./IMG-20240625-WA0056 1.png"
                      alt="error"
                      className="imgw2"
                    />
                  </SwiperSlide>
                </div>
                <div className="col-6">
                  <SwiperSlide>
                    <img src="./image 159.png" alt="error" className="imgw3" />
                  </SwiperSlide>
                </div>
                <div className="col-6">
                  <SwiperSlide>
                    <img src="./image 160.png" alt="error" className="imgw" />
                  </SwiperSlide>
                </div>
              </Swiper>
            </div>
            <div className="mt-4">
              <h2 className="text-center hdng4">BHARATPUR</h2>
              <div className="row">
                <Swiper
                  breakpoints={{
                    120: {
                      slidesPerView: 1,
                    },
                    481: {
                      slidesPerView: 2,
                    },
                    1024: {
                      slidesPerView: 2,
                    },
                  }}
                  modules={[Autoplay]}
                  spaceBetween={20}
                  slidesPerView={2}
                  autoplay
                >
                  {" "}
                  <div className="col-6 ">
                    <SwiperSlide>
                      <img src="./image 157.png" alt="error" className="imgw" />
                    </SwiperSlide>
                  </div>
                  <div className="col-6">
                    <SwiperSlide>
                      <img
                        src="./Screenshot 2024-06-26 141034 1.png"
                        alt="error"
                        className="imgw2"
                      />
                    </SwiperSlide>
                  </div>
                  <div className="col-6">
                    <SwiperSlide>
                      <img
                        src="./image 153.png"
                        alt="error"
                        className="imgw3"
                      />
                    </SwiperSlide>
                  </div>
                  <div className="col-6">
                    <SwiperSlide>
                      <img src="./image 157.png" alt="error" className="imgw" />
                    </SwiperSlide>
                  </div>
                </Swiper>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default Gallerysec2;
